import { render, staticRenderFns } from "./goToMoreSettings.vue?vue&type=template&id=571e1420&scoped=true&"
import script from "./goToMoreSettings.vue?vue&type=script&lang=ts&setup=true&"
export * from "./goToMoreSettings.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571e1420",
  null
  
)

export default component.exports